function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.01 69.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.01,3.8C-.7,8.51-1.14,11.96,2.05,19.17c1.42,3.21,2.3,8.21,2.89,16.38.47,6.47,1.35,13.03,1.96,14.57.61,1.55,1.11,5.08,1.11,7.85,0,6.57,2.45,11.84,5.51,11.84s3.49-1.6,3.51-10.83c.01-4.22.49-10.59,1.06-14.17.57-3.57,1.39-9.65,1.83-13.5.48-4.27,1.82-9.03,3.44-12.22,1.46-2.87,2.65-5.87,2.65-6.67,0-1.72-4.75-7.61-6.14-7.61-.53,0-2.62-1.12-4.64-2.5C10.25-1.08,8.68-.87,4.01,3.8",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.29,6.38c6.61,4.13,6.91,5.33,3.29,13.09-2.39,5.14-2.43,5.17-8.04,5.87-3.1.39-5.73.54-5.84.33-1.67-2.91-4.6-14-4.08-15.46,1.01-2.85,5.53-7.41,7.35-7.41.88,0,4.17,1.61,7.31,3.58",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.19,29.55c.17,1.51-.26,6.12-.96,10.25-.7,4.12-1.61,12.23-2.02,18-.65,9.26-.89,10.23-2.02,8.22-.71-1.25-1.49-5.08-1.74-8.5-.25-3.42-.87-7.57-1.37-9.22s-1.12-6.91-1.38-11.7l-.47-8.7,4.14-.38c2.27-.21,4.44-.46,4.82-.55.38-.1.83,1.06,1,2.57",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg34);
export default __webpack_public_path__ + "static/media/34.aa1e73579747370bb26e641f4a531d38.svg";
export { ForwardRef as ReactComponent };